import { render } from "./ChatMessages.vue?vue&type=template&id=5f74f880&scoped=true"
import script from "./ChatMessages.vue?vue&type=script&lang=js"
export * from "./ChatMessages.vue?vue&type=script&lang=js"

import "./ChatMessages.vue?vue&type=style&index=0&id=5f74f880&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f74f880"]])

export default __exports__